import { UserOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans } from 'react-i18next';

import MultilineParagraph from '../../components/MultilineParagraph';
import styles from './ApplicantHistory.module.css';

interface ApplicantAnnotationWithStatusTimelineProps {
  annotation?: string;
  recruiterName: string;
  createdDate: string;
  opportunityTitle: string;
  status: 'REPROVED' | 'REACTIVATED';
}

const ApplicantAnnotationWithStatusTimeline = ({
  annotation,
  recruiterName,
  createdDate,
  opportunityTitle,
  status,
}: ApplicantAnnotationWithStatusTimelineProps) => {
  return (
    <Timeline.Item
      dot={
        <UserOutlined
          className={status === 'REACTIVATED' ? styles.sucessColor : styles.errorColor}
        />
      }
    >
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          {status === 'REACTIVATED' && (
            <Typography.Text strong>
              {recruiterName} <Trans>reativou</Trans>
            </Typography.Text>
          )}
          {status === 'REPROVED' && (
            <Typography.Text strong>
              {recruiterName} <Trans>reprovou</Trans>
            </Typography.Text>
          )}{' '}
          <Trans>o(a) candidato(a) na vaga</Trans>
          <Typography.Text strong> {opportunityTitle}</Typography.Text>
        </Typography.Paragraph>
        {annotation && (
          <>
            <Divider />
            <MultilineParagraph>{annotation}</MultilineParagraph>
          </>
        )}
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantAnnotationWithStatusTimeline;
